import React, { memo } from 'react';

import { Typography } from 'antd';

import {
  ITQServiceRequestResponse,
} from '../../../../types/tqConnectTypes/service-requests';
import ResponseCard from './ResponseCard';

interface Props {
  myResponse: ITQServiceRequestResponse;
  onViewResponse: () => void;
}

const MyResponse: React.FC<Props> = ({ myResponse, onViewResponse }) => {
  return (
    <>
      <Typography.Title level={5} style={{ margin: 16 }}>
        Your response
      </Typography.Title>

      <ResponseCard
        isMyResponse
        response={myResponse}
        respondedBy={myResponse?.respondedBy}
        onViewResponse={onViewResponse}
      />
    </>
  );
};

export default memo(MyResponse);
